import { render, staticRenderFns } from "./OrderListButton.vue?vue&type=template&id=67ce21de&scoped=true"
import script from "./OrderListButton.vue?vue&type=script&lang=js"
export * from "./OrderListButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce21de",
  null
  
)

export default component.exports